"use strict";

module.exports = ['png', 'jpg', 'jpeg', 'bmp', 'tiff', 'gif'];